/* ==========================================================================
   fogd. | AURA — theme.js
   Reveal on scroll, audio cards, mobile menu, search modal, cart drawer
   ========================================================================== */

/* -------- reveal on scroll -------- */
(function(){
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, {threshold:.10});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
})();

/* -------- audio cards (Niki) -------- */
(function(){
  document.querySelectorAll('.audio-card').forEach(function(card){
    /* cards with data-track use the player in sections/niki-audios.liquid */
    if(card.hasAttribute('data-track')) return;
    var btn = card.querySelector('.play'), audio = card.querySelector('audio');
    if(!btn) return;
    btn.addEventListener('click', function(){
      if(audio && audio.src){
        document.querySelectorAll('.audio-card audio').forEach(function(a){ if(a !== audio) a.pause(); });
        if(audio.paused){ audio.play(); } else { audio.pause(); }
      }
    });
  });
})();

/* -------- money formatter (uses window.themeMoneyFormat) -------- */
function themeFormatMoney(cents){
  var fmt = window.themeMoneyFormat || '${{amount}}';
  var amount = (cents/100).toFixed(2);
  var amountNoDec = Math.round(cents/100);
  var withComma = amount.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  var euroFmt = amount.replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
  return String(fmt)
    .replace(/\{\{\s*amount\s*\}\}/g, withComma)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDec)
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, euroFmt)
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
             String(amountNoDec).replace(/(\d)(?=(\d{3})+$)/g, '$1.'));
}

function _escHtml(s){
  return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
  });
}

/* -------- mobile menu -------- */
(function(){
  var menu = document.querySelector('[data-menu]');
  var openBtn = document.querySelector('[data-menu-open]');
  if(!menu || !openBtn) return;

  function open(){
    menu.classList.add('is-open');
    openBtn.classList.add('is-open');
    menu.setAttribute('aria-hidden','false');
    openBtn.setAttribute('aria-expanded','true');
    document.body.classList.add('no-scroll');
  }
  function close(){
    menu.classList.remove('is-open');
    openBtn.classList.remove('is-open');
    menu.setAttribute('aria-hidden','true');
    openBtn.setAttribute('aria-expanded','false');
    document.body.classList.remove('no-scroll');
  }
  openBtn.addEventListener('click', function(e){ e.preventDefault(); open(); });
  menu.querySelectorAll('[data-menu-close]').forEach(function(el){ el.addEventListener('click', close); });
  menu.addEventListener('click', function(e){ if(e.target === menu) close(); });
  menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
})();

/* -------- search modal + predictive suggestions -------- */
(function(){
  var modal   = document.querySelector('[data-search]');
  var openers = document.querySelectorAll('[data-search-open]');
  if(!modal || !openers.length) return;

  var input   = modal.querySelector('[data-search-input]');
  var results = modal.querySelector('[data-search-results]');
  var debounceT;

  function open(){
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('no-scroll');
    setTimeout(function(){ input && input.focus(); }, 60);
  }
  function close(){
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('no-scroll');
  }

  openers.forEach(function(el){ el.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
  modal.querySelectorAll('[data-search-close]').forEach(function(el){ el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

  input.addEventListener('input', function(){
    clearTimeout(debounceT);
    var q = input.value.trim();
    if(!q){ results.innerHTML = ''; return; }
    debounceT = setTimeout(function(){ fetchSuggest(q); }, 220);
  });

  function fetchSuggest(q){
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,article,page,query'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=last';
    fetch(url, { headers:{ Accept:'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(data){ render(data, q); })
      .catch(function(){ results.innerHTML = '<p class="sm-empty">Search unavailable. Press Enter to search.</p>'; });
  }

  function render(data, q){
    var r = (data && data.resources && data.resources.results) || {};
    var html = '';

    if(r.queries && r.queries.length){
      html += '<div class="sm-group"><h4>Suggestions</h4><ul class="sm-list">';
      r.queries.slice(0,5).forEach(function(item){
        html += '<li><a href="/search?q=' + encodeURIComponent(item.text) + '">' + _escHtml(item.text) + '</a></li>';
      });
      html += '</ul></div>';
    }
    if(r.products && r.products.length){
      html += '<div class="sm-group"><h4>Products</h4><ul class="sm-products">';
      r.products.forEach(function(p){
        var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<div class="sm-ph"></div>';
        var price = p.price ? '<span class="sm-p-price">' + _escHtml(p.price) + '</span>' : '';
        html += '<li><a href="' + p.url + '">' + img
              + '<span class="sm-p-info"><span class="sm-p-title">' + _escHtml(p.title) + '</span>' + price + '</span></a></li>';
      });
      html += '</ul></div>';
    }
    if(r.collections && r.collections.length){
      html += '<div class="sm-group"><h4>Collections</h4><ul class="sm-list">';
      r.collections.forEach(function(c){ html += '<li><a href="' + c.url + '">' + _escHtml(c.title) + '</a></li>'; });
      html += '</ul></div>';
    }
    if(r.articles && r.articles.length){
      html += '<div class="sm-group"><h4>Journal</h4><ul class="sm-list">';
      r.articles.forEach(function(a){ html += '<li><a href="' + a.url + '">' + _escHtml(a.title) + '</a></li>'; });
      html += '</ul></div>';
    }
    if(r.pages && r.pages.length){
      html += '<div class="sm-group"><h4>Pages</h4><ul class="sm-list">';
      r.pages.forEach(function(p){ html += '<li><a href="' + p.url + '">' + _escHtml(p.title) + '</a></li>'; });
      html += '</ul></div>';
    }
    if(!html){
      html = '<p class="sm-empty">No results for &ldquo;' + _escHtml(q) + '&rdquo;. Press Enter to search everything.</p>';
    }
    results.innerHTML = html;
  }
})();

/* -------- cart drawer + AJAX add-to-cart -------- */
(function(){
  var drawer = document.querySelector('[data-cart]');
  if(!drawer) return;

  var body       = drawer.querySelector('[data-cart-body]');
  var foot       = drawer.querySelector('[data-cart-foot]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');

  function open(){
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('no-scroll');
  }
  function close(){
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('no-scroll');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function(el){
    el.addEventListener('click', function(e){ e.preventDefault(); open(); refresh(false); });
  });
  drawer.querySelectorAll('[data-cart-close]').forEach(function(el){ el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  function updateCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(b){
      b.textContent = n;
      if(n > 0){ b.removeAttribute('hidden'); } else { b.setAttribute('hidden',''); }
    });
  }

  function render(cart){
    updateCount(cart.item_count || 0);

    if(!cart.items || !cart.items.length){
      body.innerHTML = '<div class="cd-empty">Your bag is empty.</div>';
      foot.setAttribute('hidden','');
      return;
    }

    var html = '<ul class="cd-items">';
    cart.items.forEach(function(it){
      var img = it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '<div class="cd-ph"></div>';
      var vt  = (it.variant_title && it.variant_title !== 'Default Title')
              ? '<div class="cd-i-var">' + _escHtml(it.variant_title) + '</div>' : '';
      html += '<li class="cd-i" data-key="' + it.key + '">'
            +   '<a class="cd-i-img" href="' + it.url + '">' + img + '</a>'
            +   '<div class="cd-i-info">'
            +     '<a class="cd-i-title" href="' + it.url + '">' + _escHtml(it.product_title) + '</a>'
            +     vt
            +     '<div class="cd-i-row">'
            +       '<div class="cd-qty">'
            +         '<button type="button" class="cd-q" data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button>'
            +         '<span>' + it.quantity + '</span>'
            +         '<button type="button" class="cd-q" data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button>'
            +       '</div>'
            +       '<span class="cd-i-price">' + themeFormatMoney(it.final_line_price) + '</span>'
            +     '</div>'
            +     '<button type="button" class="cd-i-rm" data-key="' + it.key + '" data-qty="0">Remove</button>'
            +   '</div>'
            + '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;

    var sub = (typeof cart.items_subtotal_price === 'number') ? cart.items_subtotal_price : cart.total_price;
    subtotalEl.textContent = themeFormatMoney(sub);
    foot.removeAttribute('hidden');

    body.querySelectorAll('.cd-q, .cd-i-rm').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        if(qty < 0) qty = 0;
        change(key, qty);
      });
    });
  }

  function refresh(alsoOpen){
    return fetch('/cart.js', { headers:{ Accept:'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ render(cart); if(alsoOpen) open(); return cart; })
      .catch(function(){});
  }

  function change(key, qty){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){ return r.json(); }).then(render);
  }

  /* intercept every product form add-to-cart */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type=submit]');
    var origHtml;
    if(submitBtn){
      submitBtn.disabled = true;
      origHtml = submitBtn.innerHTML;
      submitBtn.innerHTML = 'Adding&hellip;';
    }

    var fd = new FormData(form);
    fetch('/cart/add.js', { method:'POST', body:fd, headers:{ Accept:'application/json' } })
      .then(function(r){
        if(!r.ok) return r.json().then(function(err){ throw err; });
        return r.json();
      })
      .then(function(){ return refresh(true); })
      .catch(function(err){
        var msg = (err && (err.description || err.message)) || 'Could not add item. Please try again.';
        alert(msg);
      })
      .then(function(){
        if(submitBtn){
          submitBtn.disabled = false;
          submitBtn.innerHTML = origHtml || 'Add to bag';
        }
      });
  });

  /* initial cart sync (badge count) */
  refresh(false);
})();